export default "__VITE_ASSET__BU5MpA4r__"